import { render } from "./template/RelaySetting.html?vue&type=template&id=e046c9c4&scoped=true&ts=true"
import script from "./RelaySetting.vue?vue&type=script&lang=ts"
export * from "./RelaySetting.vue?vue&type=script&lang=ts"

import "./style/RelaySetting.css?vue&type=style&index=0&id=e046c9c4&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e046c9c4"]])

export default __exports__